import React from 'react';
import { Checkbox } from 'primereact/checkbox';

export default function PFCheckbox(props) {
  return <Checkbox {...props}></Checkbox>;
}
